import {useQuery, useQueryClient} from '@tanstack/react-query';

import {apiClient} from '../../../../../utils/api-client';

function getDocumentRequest(accession: string, globalVersionId: number, revisionId?: string) {
    return apiClient.get<ViewModeDoc>({
        path: `documents-revisions-service/api/viewer/documents/${accession}/info`,
        query: {'global-version': globalVersionId, revision: revisionId}
    });
}

export type DocInfoError = 'network' | 'not-found';

export function useDocumentQuery(props: {
    accession: string;
    globalVersionId: number;
    enabled?: boolean;
    revisionId?: string;
}) {
    const queryResult = useQuery({
        queryKey: ['view-document', props.accession, props.globalVersionId, props.revisionId],
        queryFn: () => {
            return getDocumentRequest(props.accession, props.globalVersionId, props.revisionId);
        },
        enabled: props.enabled
    });

    return {
        ...queryResult,

        error: (function () {
            if (!queryResult.isError) {
                return undefined;
            }

            return (
                // FIXME this is probably not the best way of detecting whether it's a network error
                (queryResult.error instanceof TypeError ? 'network' : 'not-found') as DocInfoError
            );
        })()
    };
}

export function useDocumentQueryCache() {
    const queryClient = useQueryClient();

    function changeIsDocumentFavorite(accession: string, isFavorite: boolean) {
        queryClient.setQueriesData<ViewModeDoc>(
            {queryKey: ['view-document', accession], exact: false},
            (currentState) => {
                if (!currentState) {
                    return currentState;
                }

                return {...currentState, userFavorite: isFavorite};
            }
        );
    }

    return {changeIsDocumentFavorite};
}
